import React from 'react';
import Immutable from 'immutable';
import PropTypes from 'prop-types';
import { TicketFooterRow } from '../TicketFooter';
import i18n from '@i18n';
import ExtrasListNg from './ExtrasListNg';
import NikyStateNg from './NikyStakeNg';
import { useReframe } from 'nike-re-framejs';
import { cashinIsLoading$, evalEventualTotalsBonusGameId$ } from 'nike-ui/src/components/ticketus/subs';

function ExtrasNg({ ticket, cashinClosingModeActive }) {
    if (!((ticket.get('extras') && ticket.get('extras').size) || ticket.get('nikyStake') || ticket.get('bonusGame'))) {
        return null;
    }
    return (
        <>
            {cashinClosingModeActive ? (
                <TicketBonusGameRowClosingMode ticket={ticket} />
            ) : (
                <TicketBonusGameRow ticket={ticket} />
            )}
            {cashinClosingModeActive ? null : <ExtrasListNg extras={ticket.get('extras')} />}
            <NikyStateNg
                nikyOdds={ticket.get('nikyOdds')}
                nikyStake={ticket.get('nikyStake')}
                nikyWin={ticket.get('nikyWin')}
            />
        </>
    );
}

export function TicketBonusGameRow({ ticket }) {
    return ticket.get('bonusGame') ? (
        <TicketFooterRow rowTitle={''} rowInfo={i18n('ticketus.ticket.extras.bonusStake')} />
    ) : null;
}

export function TicketBonusGameRowClosingModeResult({ loading, bonusGameLost }) {
    if (loading) return <TicketFooterRow rowTitle={''} rowInfo={'...'} />;
    if (bonusGameLost) return <TicketFooterRow rowTitle={''} rowInfo={i18n('ticketus.ticket.extras.bonusStakeLost')} />;
    return <TicketFooterRow rowTitle={''} rowInfo={i18n('ticketus.ticket.extras.bonusStake')} />;
}

export function TicketBonusGameRowClosingMode({ ticket }) {
    const { subscribe } = useReframe();

    const ticketId = ticket.get('ticketId');
    const loading = subscribe(cashinIsLoading$(ticketId));
    const eventualBonusGameId = subscribe(evalEventualTotalsBonusGameId$(ticketId));

    const ticketBonusGame = ticket.get('bonusGame');
    const eventualBonusGame = eventualBonusGameId != null;

    const bonusGame = eventualBonusGameId !== undefined ? eventualBonusGame : ticketBonusGame;
    const bonusGameLost = ticketBonusGame && !bonusGame;

    return ticketBonusGame ? (
        <TicketBonusGameRowClosingModeResult loading={loading} bonusGameLost={bonusGameLost} />
    ) : null;
}

ExtrasNg.propTypes = {
    ticket: PropTypes.instanceOf(Immutable.Map).isRequired
};

export default ExtrasNg;
